// @flow

export default {
  setModalInvisible: (): {} => ({ type: 'SET_IS_ANY_MODAL_VISIBLE', visibility: false }),
  setModalVisible: (): {} => ({ type: 'SET_IS_ANY_MODAL_VISIBLE', visibility: true }),
};
